import React from 'react';
export function Testimonials() {
  return <section className="py-16 px-6 bg-white" data-id="element-214">
      <div className="max-w-4xl mx-auto" data-id="element-215">
        <div className="text-center mb-10" data-id="element-216">
          <h2 className="text-3xl font-extrabold text-gray-900" data-id="element-217">
            Lo que dicen los docentes de inglés que ya tienen su Pack
          </h2>
          <p className="text-gray-500 mt-2" data-id="element-218">
            +1.500 docentes de Argentina ya lo usan
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-219">
          {[{
          initials: 'PA',
          name: 'Paula Acosta',
          location: 'Córdoba | Docente de Inglés Primaria',
          text: 'Lo descargué un sábado de noche y el lunes ya tenía el año entero ordenado por grado. Las actividades no son para rellenar la hora, los chicos realmente terminan aprendiendo algo cada clase.'
        }, {
          initials: 'NC',
          name: 'Noelia Casas',
          location: 'Mendoza | Docente Primaria y Secundaria',
          text: 'Arranqué comprando solo Primaria y a la semana volví por el Pack Completo. Trabajo en los dos niveles y necesitaba todo bajo el mismo sistema. Los bonus de gestión me ahorran horas todas las semanas.'
        }, {
          initials: 'AS',
          name: 'Alejandro Sosa',
          location: 'Buenos Aires | Docente de Inglés',
          text: 'Lo mejor es que está todo separado por grado y año. Ya no tengo que estar adivinando qué nivel le pongo a cada curso. Está graduado, secuenciado y listo para usar tal cual.'
        }, {
          initials: 'MV',
          name: 'Macarena Villar',
          location: 'Tucumán | Docente de Inglés Primaria',
          text: 'Pensé que iba a ser material genérico copiado de afuera. Cuando lo abrí me di cuenta que está hecho para el aula argentina de verdad, con 30 pibes adentro y poco tiempo para preparar.'
        }, {
          initials: 'BR',
          name: 'Brenda Ramírez',
          location: 'Rosario | Docente de Inglés Secundaria',
          text: 'Mis cursos de 3ro y 4to ahora hacen las actividades sin protestar. Está todo medido al nivel justo. Ya nadie me pregunta "¿y esto para qué nos sirve?" porque se nota la lógica detrás.'
        }, {
          initials: 'CD',
          name: 'Carla Duarte',
          location: 'Santa Fe | Docente de Inglés Primaria',
          text: 'Presenté la planificación anual el primer día de clases. La directora me preguntó cómo había podido armarla tan rápido y tan completa. La verdad es que solo retoqué 5 minutos lo que ya venía hecho.'
        }].map(t => <div key={t.name} className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-220">
              <div className="flex items-center gap-3 mb-3" data-id="element-221">
                <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-sm" data-id="element-222">
                  {t.initials}
                </div>
                <div data-id="element-223">
                  <p className="font-semibold text-sm text-gray-900" data-id="element-224">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-225">📍 {t.location}</p>
                </div>
              </div>
              <p className="text-gray-700 text-sm italic" data-id="element-226">"{t.text}"</p>
            </div>)}
        </div>
      </div>
    </section>;
}